///
/// EarthBrowser
///
/// Created by Matt Giger on 9/13/2026
/// Copyright (c) 2026 Geodata Labs
///
/// v39 -> v40: Add the full-access offer snooze timestamp to the engagement
/// slice ("Not now" on the signed-in tenure offer hides the card for two
/// weeks; eligibility itself lives server-side).
///

export function migrateV39toV40(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state

	const engagement = (s.engagement && typeof s.engagement === "object")
		? s.engagement as Record<string, unknown>
		: {}
	if ("offerSnoozedUntil" in engagement) return state

	return {
		...s,
		engagement: {
			...engagement,
			offerSnoozedUntil: null,
		},
	}
}
